import { useEffect, useState, useMemo } from "react";
import { Button, Stack } from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import withReducer from "services/withReducer";
import { MdAdd } from "react-icons/md";
import Loader from "components/loader";
import Cart from "./components/food_cart";
import Foods from "./components/foods";
import reducer from "./store";
import FoodAdd from "./components/food_add";
import {
  setOpenModal,
  getFoodOptions,
  getSaleFoods,
  getFoods,
} from "./store/saleSlice";

const FoodSale = () => {
  const dispatch = useDispatch();
  const foods = useSelector(getFoods);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchFoods();
    dispatch(getFoodOptions());

    // eslint-disable-next-line
  }, [dispatch]);

  const fetchFoods = () => {
    setLoading(true);
    dispatch(getSaleFoods()).then((res) => setLoading(false));
  };

  // Hoolnii datag category goor ni grouplej baina
  const groupedData = useMemo(() => {
    return foods.reduce((acc, item) => {
      if (!acc[item.food_type]) {
        acc[item.food_type] = [];
      }
      acc[item.food_type].push(item);
      return acc;
    }, {});
  }, [foods]);

  return (
    <div className="mt-5 w-full flex flex-row gap-4">
      {/* Хоолны жагсаалт */}
      <div className="food-card px-6 pb-6 pt-4 flex-1">
        <Stack direction="row">
          <div className="food-card-header-title !text-[19px]">
            Хоолны жагсаалт
          </div>
          <Button
            colorScheme="customGreen"
            size="sm"
            onClick={() => dispatch(setOpenModal(true))}
          >
            <MdAdd /> Хоол нэмэх
          </Button>
        </Stack>

        {/* Хоолнууд */}
        {loading ? (
          <Loader />
        ) : (
          Object.entries(groupedData).map(([foodType, foods]) => (
            <Foods key={foodType} title={foodType} foods={foods} />
          ))
        )}
      </div>

      {/* Сонгогдсон хоолнууд */}
      <div className="food-card px-6 pb-6 pt-4 flex-1">
        <div className="food-card-header-title !text-[19px]">
          Сонгогдсон хоолнууд
        </div>
        {/* Cart */}
        {loading ? <Loader /> : <Cart />}
      </div>
      <FoodAdd />
    </div>
  );
};

export default withReducer("sale", reducer)(FoodSale);
